var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReturnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0033 1.10367V6.07021C16.0033 6.68033 15.5097 7.17388 14.8996 7.17388H9.93307C9.32294 7.17388 8.82939 6.68033 8.82939 6.07021C8.82939 5.46008 9.32294 4.96653 9.93307 4.96653H12.1194C11.0857 3.59729 9.45504 2.76677 7.71848 2.76677C4.68027 2.76677 2.20735 5.239 2.20735 8.27756C2.20735 11.3161 4.67992 13.789 7.71882 13.789C8.92183 13.789 10.0652 13.4086 11.0257 12.6874C11.5162 12.3242 12.2059 12.4201 12.5712 12.9073C12.9364 13.3957 12.8385 14.0875 12.3513 14.4528C11.0052 15.4626 9.40727 16 7.72279 16C3.46623 15.9998 0 12.5336 0 8.27756C0 4.02151 3.46623 0.555286 7.72227 0.555286C10.1072 0.555286 12.3439 1.67517 13.7959 3.52555V1.10367C13.7959 0.493549 14.2895 0 14.8996 0C15.5097 0 16.0033 0.493549 16.0033 1.10367Z",
    fill: "#2290B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnIcon);
export default __webpack_public_path__ + "static/media/return_icon.071c512dafc05006e0043d1923c5eb9a.svg";
export { ForwardRef as ReactComponent };